import { call, put, takeLatest } from 'redux-saga/effects';
import { Apis } from 'src/services/api';
import { addUserAsync, getUsersAsync, updateUserAsync } from './actions';

function* getUsers(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) {
      const data = response.data ?? { tasks: [], total: 0 };
      yield put(getUsersAsync.success(data));
    } else yield put(getUsersAsync.failure(response));
  } catch (err) {
    yield put(getUsersAsync.failure(err));
  }
}

function* updateUser(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) yield put(updateUserAsync.success(response));
    else yield put(updateUserAsync.failure(response));
  } catch (err) {
    yield put(updateUserAsync.failure(err));
  }
}

function* addUser(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) yield put(addUserAsync.success(response));
    else yield put(addUserAsync.failure(response));
  } catch (err) {
    yield put(addUserAsync.failure(err));
  }
}

export default function usersSaga(apiInstance: Apis) {
  return [
    takeLatest(getUsersAsync.request, getUsers, apiInstance.getUsers),
    takeLatest(updateUserAsync.request, updateUser, apiInstance.updateUser),
    takeLatest(addUserAsync.request, addUser, apiInstance.addUser),
  ];
}
